import type { Team, TeamPlan, User } from "@alch/dx-entities";
import type {
  CustomerioEvent,
  CustomerioEventProps,
} from "@alch/dx-entities/analytics/customerio";
import {
  buildCustomerioTeamTraits,
  buildCustomerioUserTraits,
} from "@alch/dx-utils/analytics/customerio";
import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

let analytics: AnalyticsBrowser | undefined;

export function initCustomerio(debug?: boolean) {
  if (analytics || !import.meta.env.VITE_CUSTOMERIO_WRITE_KEY) {
    return;
  }

  analytics = AnalyticsBrowser.load({
    writeKey: String(import.meta.env.VITE_CUSTOMERIO_WRITE_KEY),
  });

  if (debug) {
    console.debug("[customer.io] load");
  }
}

export function identifyCustomerioUser(
  {
    user,
    team,
    activePlan,
  }: { user: User; team?: Team; activePlan?: TeamPlan },
  debug?: boolean,
) {
  void analytics?.identify(String(user.id), buildCustomerioUserTraits(user));

  if (team && activePlan) {
    void analytics?.group(
      String(team.id),
      buildCustomerioTeamTraits({ team, activePlan }),
    );
  }

  if (debug) {
    console.debug("[customer.io] identify", user);
  }
}

export function trackCustomerioEvent<
  TEvent extends CustomerioEvent,
  TProps extends CustomerioEventProps[TEvent],
>(event: TEvent, props: TProps, debug?: boolean) {
  void analytics?.track(event, props);

  if (debug) {
    console.debug("[customer.io] track", event, props);
  }
}

export function trackCustomerioPage(debug?: boolean) {
  void analytics?.page();

  if (debug) {
    console.debug("[customer.io] page");
  }
}

export function resetCustomerioUser(debug?: boolean) {
  void analytics?.reset();

  if (debug) {
    console.debug("[customer.io] reset");
  }
}
